module.exports = __webpack_public_path__ + "static/media/dominican-trip.1c546cc5.png";